import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components/macro';
import DOMPurify from 'dompurify';

import { os } from '@mirinae/js-utils/utils/userAgent';
import { classes } from '@mirinae/react-ui';
import Element from '@mirinae/lessons/components/lesson/elements/Element';
import axios from 'axios';
import { FormattedTextField } from '@mirinae/lessons/components/lesson/elements/Text';

const TextCardElement = styled(Element)`
    display: flex;
    flex-direction: row;
    justify-content: center;;
    ${!os.isOthers && 'min-width: 100%;'}
`;

const CardWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    height: ${os.isOthers ? '100%' : 'fit-content'};
    width: ${props => (os.isOthers ? '100%' : `${props.geom.width}px`)};
    ${props => os.isOthers && `min-width: ${props.geom.width}px`};
    ${!os.isOthers && 'max-width: calc(100vw - 100px);'} // room for the side stpe-controls in mobile on narrow phones 
`;

const Card = styled.div`
    display: flex;
    width: 400px;
    height: ${os.isOthers ? '360px' : 'fit-content'};
    flex-direction: column;
    align-items: start;
    justify-content: center;
    padding-left: 40px;
    gap: 10px;
  
    & span {
      line-height: 150%; 
    }
  
    .${classes.mobile} & {
        justify-content: start;
    }
`;

const CardTitle = styled(FormattedTextField)`
    // color: #48A9A6;
    // font-size: ${os.isOthers ? 18 : 20}px !important;
    // font-weight: 700;
    // line-height: 100%; /* 20px */
`;

const CardText = styled(FormattedTextField)`
    color: #525252;
    font-size: 18px;
    font-weight: 400;
  
    .${classes.mobile} & {
        & span {
            font-size: 16px;
        }
    }
`;

const TextCard = ({ element, geomElement }) => {
    const [showPronunciation, setShowPronunciation] = useState(false);
    const svgEmbedRef = useRef(null);
    const geomEl = geomElement || element;

    return (
        <TextCardElement className={`el-${element.componentName}`} element={element} geomElement={geomEl}>
            <CardWrapper geom={os.isOthers ? geomEl.geom : (geomEl.mobile && geomEl.mobile.geom)}>
                <Card className="text-card">
                    { element.fieldsByName.cardTitle.value && <CardTitle element={element} field={element.fieldsByName.cardTitle} /> }
                    { element.fieldsByName.text.value && <CardText element={element} field={element.fieldsByName.text} /> }
                </Card>
            </CardWrapper>
        </TextCardElement>
    );
};

export default TextCard;
